module.exports = __webpack_public_path__ + "assets/img/e3a2647ffb22d188e3d9944398bef8b7.svg";